"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsigEndpoint = void 0;
var StatsigEndpoint;
(function (StatsigEndpoint) {
    StatsigEndpoint["Initialize"] = "initialize";
    StatsigEndpoint["Rgstr"] = "rgstr";
    StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
})(StatsigEndpoint = exports.StatsigEndpoint || (exports.StatsigEndpoint = {}));
class StatsigNetwork {
    constructor(sdkInternal) {
        this.retryCodes = {
            408: true,
            500: true,
            502: true,
            503: true,
            504: true,
            522: true,
            524: true,
            599: true,
        };
        this.canUseKeepalive = false;
        this.sdkInternal = sdkInternal;
        this.leakyBucket = {};
        this.init();
    }
    init() {
        if (!this.sdkInternal.getOptions().getDisableNetworkKeepalive()) {
            try {
                this.canUseKeepalive = 'keepalive' in new Request('');
            }
            catch (_e) { }
        }
    }
    fetchValues(user, timeout, resolveCallback, rejectCallback) {
        return this.postWithTimeout(StatsigEndpoint.Initialize, {
            user: user,
            statsigMetadata: this.sdkInternal.getStatsigMetadata(),
        }, resolveCallback, rejectCallback, timeout, // timeout for early returns
        10);
    }
    postWithTimeout(endpointName, body, resolveCallback, rejectCallback, timeout = 0, retries = 0, backoff = 1000) {
        const fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff)
            .then((res) => {
            if (res.ok) {
                return res.json().then((json) => {
                    resolveCallback(json);
                    return Promise.resolve(json);
                });
            }
            return Promise.reject(new Error('Request to ' + endpointName + ' failed with status ' + res.status));
        })
            .catch((e) => {
            if (typeof rejectCallback === 'function') {
                rejectCallback(e);
            }
            return Promise.reject(e);
        });
        if (timeout != 0) {
            const timer = new Promise((resolve, reject) => {
                setTimeout(() => {
                    resolve();
                }, timeout);
            });
            return Promise.race([fetchPromise, timer]);
        }
        return fetchPromise;
    }
    sendLogBeacon(payload) {
        if (this.sdkInternal.getOptions().getLocalModeEnabled()) {
            return true;
        }
        const url = new URL(this.sdkInternal.getOptions().getApi() + StatsigEndpoint.LogEventBeacon);
        url.searchParams.append('k', this.sdkInternal.getSDKKey());
        payload.clientTime = Date.now() + '';
        let stringPayload = null;
        try {
            stringPayload = JSON.stringify(payload);
        }
        catch (_e) {
            return false;
        }
        return navigator.sendBeacon(url.toString(), stringPayload);
    }
    postToEndpoint(endpointName, body, retries = 0, backoff = 1000, useKeepalive = false) {
        if (this.sdkInternal.getOptions().getLocalModeEnabled()) {
            return Promise.reject('no network requests in localMode');
        }
        const url = this.sdkInternal.getOptions().getApi() + endpointName;
        const counter = this.leakyBucket[url];
        if (counter != null && counter >= 30) {
            return Promise.reject(new Error('Request failed because you are making the same request too frequently.'));
        }
        if (counter == null) {
            this.leakyBucket[url] = 1;
        }
        else {
            this.leakyBucket[url] = counter + 1;
        }
        const params = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'STATSIG-API-KEY': this.sdkInternal.getSDKKey(),
                'STATSIG-CLIENT-TIME': Date.now() + '',
            },
        };
        if (this.canUseKeepalive && useKeepalive) {
            params.keepalive = true;
        }
        return fetch(url, params)
            .then((res) => {
            if (res.ok) {
                return Promise.resolve(res);
            }
            if (!this.retryCodes[res.status]) {
                retries = 0;
            }
            return res.text().then((errorText) => {
                return Promise.reject(new Error(`${res.status}: ${errorText}`));
            });
        })
            .catch((e) => {
            if (retries > 0) {
                return new Promise((resolve, reject) => {
                    setTimeout(() => {
                        this.leakyBucket[url] = Math.max(this.leakyBucket[url] - 1, 0);
                        this.postToEndpoint(endpointName, body, retries - 1, backoff * 2)
                            .then(resolve)
                            .catch(reject);
                    }, backoff);
                });
            }
            return Promise.reject(e);
        })
            .finally(() => {
            this.leakyBucket[url] = Math.max(this.leakyBucket[url] - 1, 0);
        });
    }
    supportsKeepalive() {
        return this.canUseKeepalive;
    }
}
exports.default = StatsigNetwork;
